import { useState } from "react";
import { useNavigate } from "react-router";
import useFetch from "../../hooks/useFetch";
import { Link } from "react-router-dom";
import CreateSupplier from "../Supplier/CreateSupplier";

export default function Suppliers() {
    const { data, isLoading } = useFetch('reports/GetTspReportSellers');
    const navigate = useNavigate();

    const [searchTerm, setSearchTerm] = useState("");

    const handleTspReportClick = (id) => {
        const route = `/tspsupplierreport`;
        navigate(route);
    };

    const handleGraphClick = (id, name) => {
        const route = `/supplier-data-graph`;
        navigate(route, { state: { id, name } });
    };

    // Filter data based on search term
    const filteredData = data?.filter(supplier =>
        supplier.name?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    if (isLoading) {
        return (
            <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                    <h1 className="h2"> <i className="fa-solid fa-spinner fa-spin"></i></h1>
                </div>
            </main>
        );
    }

    return (
        <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                <h1 className="h2 float-start">
                    <Link to={"/supplier-tsp-report"}>
                        <i className="fa-solid fa-arrow-left"></i>
                    </Link>
                    Suppliers
                </h1>
                <div className="col-sm-8">
                    <CreateSupplier />
                </div>
            </div>

            {/* Search Input */}
            <div className="mb-3">
             <div className="col-sm-4 position-relative">
                <input
                    type="text"
                    className="form-control"
                    placeholder="Search... "
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                     className="form-control"
                />
                <span className="fa fa-search department-search-icon"></span>
                </div>
            </div>

            <table className="table">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>TSP Report</th>
                        <th>Graph Report</th>
                    </tr>
                </thead>
                <tbody>
                    {filteredData && filteredData.length > 0 ? (
                        filteredData.map(({ id, name }) => (
                            <tr key={id}>
                                <td>{name}</td>
                                <td>
                                    <button
                                        className="btn btn-primary btn-add"
                                        onClick={() => handleTspReportClick(id)}
                                    >
                                        TSP Report
                                    </button>
                                </td>
                                <td>
                                    <button
                                        className="btn btn-primary btn-add"
                                        onClick={() => handleGraphClick(id, name)}
                                    >
                                        Graph Report
                                    </button>
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="3" className="text-center">
                                No supplier available.
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </main>
    );
}
